module.exports = __webpack_public_path__ + "07357fc0dab1c0380885201bfe04875f.pdf";